import type { ICashRegisterPort } from '@onboarding/application/ports';
import type { CashRegisterConfig } from '@onboarding/domain/value-objects';
import { CASH_REGISTER_TYPES } from '@onboarding/domain/value-objects';
import type { OnboardingHttpClientType } from '@onboarding/infrastructure/api';

const CASH_REGISTER_NAMESPACE = 'CASH_REGISTER';

const DEFAULT_CASH_REGISTER_SETTINGS = {
  blindClosing: true,
  closingWithOpenOrders: false,
  sections: [] as string[],
  storeReceipt: true,
  deliveryReceipt: true,
};

/**
 * Concrete implementation of ICashRegisterPort.
 * Uses GET → merge → PUT strategy to avoid overwriting unrelated settings.
 */
export const createCashRegisterRepository = (props: { httpClient: OnboardingHttpClientType }): ICashRegisterPort => {
  const { httpClient } = props;

  const applyCashRegisterConfig = async (config: CashRegisterConfig): Promise<void> => {
    const storeSettings = await httpClient.getStoreSettings();
    const currentCashRegister = storeSettings.cashRegister ?? DEFAULT_CASH_REGISTER_SETTINGS;

    await httpClient.updateStoreSettings([
      {
        namespace: CASH_REGISTER_NAMESPACE,
        settings: {
          ...currentCashRegister,
          blindClosing: config.cutType === CASH_REGISTER_TYPES.BLIND,
        },
      },
    ]);
  };

  return { applyCashRegisterConfig };
};
